import React from "react";
import MapComponent from "../shared/map_component";


const Map = () => {
    return (
        <>
            <MapComponent mapClassName='min-h-[90vh]'/>
        </>
    );
};

export default Map;
